<template>
  <span v-if="hasLocation && hasDownload()"
        v-b-tooltip.hover.nofade='{ delay: { "show": 500, "hide": 100 } }'
        :title="$t('Webportal.DownloadReportFiles')"
        class="cx-search-icon cx-clickable-icon"
        @click="handleDownload">
    <i class="fas fa-file-pdf mx-2"></i>
  </span>
</template>

<script>
export default {
  beforeMount() {
    if (this.params.data) {
      this.location = this.params.data;
    } else if (this.params.node.group && this.params.node.level === 0) {
      const regex = /___(\d+)$/;
      let number = this.params.node.key.match(regex) ? this.params.node.key.match(regex)[1] : undefined;
      this.location = this.params.context.getLocation(parseInt(number));
    }
  },

  computed: {
    hasLocation() {
      return !!this.location;
    }
  },
  
  methods: {
    hasDownload() {
      return this.location.LastSurveyInstanceIds && this.location.LastSurveyInstanceIds.length > 0;
    },

    handleDownload(event) {
      this.params.context.onClickDownload(this.location);
    }
  }
}
</script>

<style>
  .jlr-number-item-style  {
    line-height: 1.5rem!important; 
    padding-top: 10px!important; 
    padding-bottom: 10px!important;
    text-align: left; 
    text-align: -webkit-left;
  }
  
  .jlr-number-item-style div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

</style>